import React from "react";
import { STATUS_CONFIG } from "../lib/api";

export default function StatusBadge({ status, className = "" }) {
  const cfg = STATUS_CONFIG[status] || { color: "#71717A", label: status };
  return (
    <span
      className={`inline-flex items-center gap-2 border border-neutral-200 px-2.5 py-1 text-xs font-medium ${className}`}
      data-testid={`status-badge-${status}`}
    >
      <span className="status-dot" style={{ background: cfg.color }} />
      {cfg.label}
    </span>
  );
}
